

import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get } from "lodash";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import "./usermanagement.css";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { bottom } from "@popperjs/core";
import dummyProfile from "../../assets/images/lady.png";
import Stars from 'react-stars';

import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import TextArea from "../../components/TextArea";
import ReactReadMoreReadLess from "react-read-more-read-less";
import { AiOutlineDownload } from "react-icons/ai";

import {
  extractDate,
  extractOnlyDate,
  extractOnlyMonthYear,
  getFileSize,
  maskToken,
  maskSocialSecurityNumber,
  uploadImage,
  subadminAccessChange,
} from "../../utils/functions";

// Mui & material UI
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import Checkbox from '@mui/material/Checkbox';
import SearchBar from "material-ui-search-bar";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import PaginationItem from '@mui/material/PaginationItem';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { TextField, Popover, Box } from "@mui/material";

// icons
import { IoIosLink } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { IoCallOutline } from "react-icons/io5";
import { IoLocationOutline } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { LuContact } from "react-icons/lu";
import { GoCalendar } from "react-icons/go";
import { SlPencil } from "react-icons/sl";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { PiAndroidLogoFill } from "react-icons/pi";
import { MdOutlineFileDownload } from "react-icons/md";

import { SlClose } from "react-icons/sl";
import { RxCross2 } from "react-icons/rx";
import { FaArrowLeft } from "react-icons/fa";
import { IoIosLogOut } from "react-icons/io";
import { TiInfoOutline, TiTick } from "react-icons/ti";
import { BiSolidPackage } from "react-icons/bi";
import { RxCrossCircled } from "react-icons/rx";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { GrApple, GrAndroid } from "react-icons/gr";
import { BsDot, BsEyeFill, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import { PiHandsClappingBold, PiUserList, PiXCircleFill } from "react-icons/pi";

import JPG from "../../assets/images/jpg.png";
import placeholder from "../../assets/images/placeholder.jpg";
import Pdf from "../../assets/images/Pdf.png";
import certificate from "../../assets/images/ApproveCertificate.png";
import medal from "../../assets/images/medal.png";
import defaultImage from "../../assets/images/ic_diner 1.png"
import visa from "../../assets/images/ic_visa 1.png";
import amez from "../../assets/images/ic_amez 1.png";
import diner from "../../assets/images/ic_diner 1.png";
import discover from "../../assets/images/ic_discover 1.png";
import jcb from "../../assets/images/ic_jcb 1.png";
import mada from "../../assets/images/ic_mada 1.png";
import maestro from "../../assets/images/ic_maestro 1.png";
import mastercard from "../../assets/images/ic_mastercard 1.png";
import union from "../../assets/images/ic_union_pay 1.png";
import Fire from "../../assets/images/fair.png";
import Star from "../../assets/images/star.png"

import {
  MdBlock,
  MdClose,
  MdEmail,
  MdLocalPhone,
  MdPhone,
} from "react-icons/md";
import {
  IoArchive,
  IoArrowBackCircleOutline,
  IoArrowForwardCircleOutline,
} from "react-icons/io5";
import {
  FaFilter,
  FaGlobe,
  FaPhone,
  FaUser,
  FaUserAlt,
  FaMoneyBill,
  FaCheckCircle,
} from "react-icons/fa";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  ProfileDetailForm,
  ServiceDetailForm,
  DashHeading,
  Button,
  Filter,
  DpBox,
  Fields,
  Resetbtn,
  Applybtn,
} from "./UserManagementElements";
import FileSizeDisplay from "../../components/FileSize";
import android from "../../assets/images/Androide.png";
import NoResults from "../../components/NoResult";
import Loading from "../../components/Loading";

const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 10px', // adds vertical spacing between rows
  },
  paperTableHeight: {
    width: "97%",
    marginLeft: "1rem",
    minHeight: "40vh",
    border: "1px solid rgba(12, 45, 6, 0.10)",
    borderRadius: "10px",
    overflow: "scroll",
  },
  tableMainContainer: {
    maxHeight: "50vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    // border: "1px solid rgba(17, 153, 38, 0.20)",

  },
  tableBodyRow: {
    background: "#FFFFFF",
    // border: "1px solid rgba(17, 153, 38, 0.20)",

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    // padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#1C2D28",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
    background: "#FFFFFF",
    border: "none"
  },
  textMiddle: {
    // padding: "0.4rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#484848",
    fontFamily: "Roboto",
    fontWeight: "400",
    background: "#FFFFFF",
    border: "none"
  },
  tablePaginationStyle: {
    borderTop: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  paginationContainer: {
    marginTop: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));





const UserDetails = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "User Management"
  )?.permissions || {};

  const canView = !!userManagementPermissions.view;
  const canAdd = !!userManagementPermissions.add;
  const canEdit = !!userManagementPermissions.edit;
  const canDelete = !!userManagementPermissions.delete;
  const canBlockUnblock = !!userManagementPermissions.blockUnblock;
  const canDownload = !!userManagementPermissions.download;


  const param = useParams();
  const location = useLocation();
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [popoverUserDetails, setPopoverUserDetails] = useState();
  const [userCertificate, setUserCertificate] = useState()
  const [rejectionReason, setRejectionReason] = useState("");
  const [certificateId, setCertificateId] = useState(null);

  const [blockModal, setBlockModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approvedCertificate, setApprovedCertificate] = useState(false);
  const [rejectCertificate, setRejectCertificate] = useState(false);

  const [showTable, setShowTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [userGigStatus, setUserGigStatus] = useState([]);
  console.log("userGigStatuserfgerfge", userGigStatus)
  const [activityGigStatus, setActivityGigStatus] = useState([]);
  const [reatingStatus, setReatingStatus] = useState([]);
  const [rejectedCount, setRejectedCount] = useState()



  const [profileChecked, setProfileChecked] = useState(false);
  const [documentChecked, setDocumentChecked] = useState(false);
  const [profileReason, setProfileReason] = useState("");
  const [documentReason, setDocumentReason] = useState("");

  const [filterStatus, setFilterStatus] = useState(1)
  const [pageTypeData, setPageTypeData] = useState("")
  const [typeData, setTypeData] = useState("worker")
  const [paymentTypeData, setPaymentTypeData] = useState("paid")
  const [tabSwitch, setTabSwitch] = useState(1)
  const [tabSwitchPayment, setTabSwitchPayment] = useState(1)
  const [overAllReating, setOverAllReating] = useState();
  const [cardDetails, setCardDetails] = useState([]);






  const [userHistory, setUserHistory] = useState();

  const [anchorEl, setAnchorEl] = useState(null);


  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the filter popover
  };

  const handleClose = () => {
    setAnchorEl(null); // Only close the popover without resetting
  };

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;



  const opt = {
    1: "Paid",
    2: "Received",
    3: "Cancelled",
    0: "All Payment"
  };

  const [showCustomFilter, setShowCustomFilter] = useState(false);
  const [time, setTime] = React.useState('');
  const [onOpen, setOnOpen] = useState(false);


  const [verificationDocumentModal, setVerificationDocumentModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(""); // Store clicked image source

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
    setVerificationDocumentModal(true);
  };


  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1);  // Reset to first page when changing rows per page
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Update page and trigger data fetch
  };




  // For Select checkbox
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (tableData.length === 0) {
      setSelectedRows([]);
    }
  }, [tableData]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(tableData.map((item) => item._id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    const newSelectedRows = selectedRows.includes(id)
      ? selectedRows.filter((rowId) => rowId !== id)
      : [...selectedRows, id];
    setSelectedRows(newSelectedRows);
  };

  const handleClearSelection = () => {
    setSelectedRows([]);
  };


  //  this is for open history
  const handleClick = () => {
    setShowTable(!showTable);
  };



  useEffect(() => {
  if (param?.id) {
    getUserDetails(page);
    getUserHistory(page);
    getUserGigStatusData(page);
  }
}, [param?.id, page, rowsPerPage, pageTypeData, typeData, paymentTypeData]);


  const getUserDetails = async () => {
    setIsLoading(true);

    try {
      const { data } = await axios.get(`/private/getUserDetails/${param?.id}`);
      console.log("getUserDetails",data)

      setUserDetails(data?.data[0]);
      setPopoverUserDetails(data?.data[0])
      setUserCertificate(data?.data[0]?.certificateData)
    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };


  const getUserGigStatusData = async (currentPage) => {
    setIsLoading(true);
    setTotalDocs(0);

    try {
      const { data } = await axios.post(`/private/getUserGigStatusData/${param?.id}?page=${currentPage}&limit=${rowsPerPage}`, {
        pageType: String(pageTypeData),  //["hostedGig","appliedGig","activityGig"]
        type: String(typeData), //host,"worker"
        paymentType: String(paymentTypeData)
      },
      );
      console.log("getUserGigStatusData", data)



      setTotalDocs(data?.data?.totalDocs);
      setUserGigStatus(data?.data?.docs);
      setActivityGigStatus(data?.data);
      setReatingStatus(data?.data?.docs)
      setRejectedCount(data);
      setCardDetails(data?.cardDetails);
      setOverAllReating(data?.streakData[0]);


    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };



  // Block unblock functionality
  const blockUnblock = async () => {
    try {
      const response = await axios.post(`/private/userBlock/${param?.id}`);

      toast.success(response.data.message, {
        position: "top-right",
      });
      getUserDetails(page);
    } catch (error) {

      // if (error.response?.status === 401) {
      //   toast.error(error.response.data?.errors[0]?.msg, {
      //     position: "top-right",
      //   });
      // } else 
      if (error.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        toast.error(error.response.data?.message, {
          position: "top-right",
        });
        navigate("/");
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
        });
      }
    }
  };



  const DeleteUser = async () => {
    try {
      const refData = {
        ids: [param?.id]
      }

      const { data } = await axios({
        method: 'delete',
        url: `/private/deleteUsers`,
        data: refData
      });

      toast.success(data?.message);
      getUserDetails(page);
    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        toast.error('Something went wrong', {
          position: "top-right",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };



  // userViewHistory

  const getUserHistory = async () => {
    setIsLoading(true);
    //  setIsLoading(true);
    // setTotalDocs(0);

    try {
      const { data } = await axios.get(`/private/userViewHistoryfind/${param?.id}`);
      setUserHistory(data?.data);

    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };



  // approve && Reject
  const handleApprove = async (id) => {
    setIsLoading(true)
    try {
      const response = await axios.put(`/private/certificate/approvedRejected/${id}`,
        {
          status: "2",   //3 reject and 2 Approve        
        }
      );
      toast.success(response.data.message, {
        position: "top-right",
      });
      getUserDetails(page);
    } catch (error) {


      if (error.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        toast.error(error.response.data?.message, {
          position: "top-right",
        });
        navigate("/");
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
        });
      }
    }
  };


  const handleReject = async (id) => {
    if (!rejectionReason.trim()) {
      toast.error("Please enter a reason for rejection.");
      setRejectCertificate(true)

      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.put(`/private/certificate/approvedRejected/${id}`, {
        status: "3", // 3 = Rejected
        rejectionReason: rejectionReason.trim()
      });
      toast.success(response.data.message, {
        position: "top-right",
      });
      getUserDetails(page);
    } catch (error) {

      // if (error.response?.status === 401) {
      //   toast.error(error.response.data?.errors[0]?.msg, {
      //     position: "top-right",
      //   });
      // } else 
      if (error.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        toast.error(error.response.data?.message, {
          position: "top-right",
        });
        navigate("/");
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
        });
      }
    }
  };




  const download = async (data) => {
    try {
      const link = document.createElement('a');
      link.href = data; // 'data' should be a URL or Blob URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleDownload = (url) => {
    if (!url) {
      alert("Resume not available");
      return;
    }

    // Create a temporary anchor tag to download the file
    const link = document.createElement("a");
    link.href = url;
    link.download = ""; // You can set a custom filename here if needed
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadCertificate = async (data) => {
    try {
      const link = document.createElement('a');
      link.href = data; // 'data' should be a URL or Blob URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };


  const backRoute =
    location.state?.from === "userManagement"
      ? "/userManagement"
      : location.state?.from === "reportedGigManagement"
        ? "/reportedGigManagement"
        : location.state?.from === "gigsManagement"
          ? "/gigsManagement"
          : location.state?.from === "reportUserList"
            ? "/reportedGigManagement"
            : location.state?.from === "leaderboardManagement"
              ? "/leaderboardManagement"
              : location.state?.from === "feedbackManagement"
                ? "/feedbackManagement"
                : location.state?.from === "ticketManagement"
                  ? "/ticketManagement"
                  : "/dashboard";



  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm style={{ gap: "1rem" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer"
              }}
            >
              <div
                // onClick={() => navigate(backRoute)}
                onClick={() => {
                  navigate(backRoute, {
                    state: {
                      page: location.state?.page,
                      rowsPerPage: location.state?.rowsPerPage,
                      tabStatus: location.state?.tabStatus,
                    },
                  });
                }}
              >

                <HiArrowNarrowLeft style={{ fontSize: "1.2rem" }} />
                <span className="common-heading ps-2"> {userDetails?.fullName}'s Profile</span>
              </div>
              {userDetails?.isStripeVerified == true && (
                <div style={{ display: "flex", gap: "10px" }}>
                  {userDetails?.isBlocked == 2 ? (
                    !(!canBlockUnblock && adminData?.userType === "subAdmin") && (
                      <button className="user" style={{ backgroundColor: "#5088FB", color: "#FFFFFF" }} onClick={() => setBlockModal(true)}
                      >Block User</button>)
                  ) : (
                    !(!canBlockUnblock && adminData?.userType === "subAdmin") && (
                      <button className="user" style={{ backgroundColor: "#5088FB", color: "#FFFFFF" }} onClick={() => setBlockModal(true)}
                      >Unblock User</button>
                    ))
                  }
                  {!(!canDelete && adminData?.userType === "subAdmin") && (
                    <button className="user"
                      style={{ backgroundColor: "#FF4141", color: "#FFFFFF" }}
                      onClick={() => { setDeleteModal(true); }}
                    >
                      Delete User</button>
                  )}
                </div>
              )}
            </div>

            <div className="userDetailsdataa">
              <div className="user_card_1">
                <div className="user_img">
                  {userDetails?.profileImage ? (

                    <img src={userDetails?.profileImage} style={{ height: "192px", width: "191px", }} />
                  ) : (
                    <img src={placeholder} style={{ height: "192px", width: "191px", }} />
                  )}

                </div>
                <div className="text_info">
                  <p className="common-heading ">{userDetails?.fullName}</p>
                  <span style={{ display: "flex", gap: "1rem", color: "#484848", fontWeight: "500", fontSize: "14px" }}>
                    <LuContact className="user_icons" />
                    {userDetails?.userId}
                    <GoCalendar className="user_icons" />
                    {extractDate(userDetails?.createdAt)}
                  </span>
                  <div style={{ display: 'flex', alignItems: "baseline", gap: "10px" }}>
                    <SlPencil className="user_icons" style={{ marginTop: "20px" }} />
                    <p style={{ marginTop: "6px", display: "flex", gap: "1rem", color: "#484848", fontWeight: "400", fontSize: "16px", overflowWrap: "anywhere" }}>{userDetails?.bio}</p>
                  </div>
                </div>

              </div>
              <div className="biodata">
                {/* <button
                  onClick={() => download(userDetails?.resume)}
                  disabled={!userDetails?.resume}
                >
                  Resume <MdOutlineFileDownload />
                </button> */}
                <div className="details_data" style={{ marginTop: "4.5rem" }}>
                  <div className="main_user" ><AiOutlineMail className="user_icons" /> <span style={{ color: "#2960C0", fontWeight: "400", fontSize: "14px", fontFamily: "Roboto" }}>{userDetails?.email ?? "N/A"}</span></div>
                  <div className="main_user"><IoCallOutline className="user_icons" /> <span style={{ color: "#000000", fontWeight: "400", fontSize: "14px" }}>{userDetails?.countryCode} {userDetails?.phoneNumber ?? "N/A"}</span></div>
                  <div className="main_user"><IoIosLink className="user_icons" /> <span style={{ color: "#2960C0", fontWeight: "400", fontSize: "14px", fontFamily: "Roboto" }}>{userDetails?.websiteUrl ?? "N/A"}</span></div>
                  <div className="main_user"><IoLocationOutline className="user_icons" /> <span style={{ color: "#000000", fontWeight: "400", fontSize: "14px", fontFamily: "Roboto" }}>{userDetails?.zipCode ?? "N/A"}</span></div>
                </div>
              </div>
            </div>


            <div className="nav_button">
              <div className={`nav_button_text ${filterStatus == 1 ? 'active' : ''
                }`}
                onClick={() => {
                  setFilterStatus(1);
                }}
              >
                Profile</div>
              <div className={`nav_button_text ${filterStatus == 2 ? 'active' : ''
                }`}
                onClick={() => {
                  setFilterStatus(2);
                  setPageTypeData("activityGig")
                  setPage(1)
                }}
              >
                Activity</div>
              <div className={`nav_button_text ${filterStatus == 3 ? 'active' : ''
                }`}
                onClick={() => {
                  setFilterStatus(3);
                  setPageTypeData("appliedGig")
                  setPage(1)
                }}
              >
                Applied Gigs</div>
              <div className={`nav_button_text ${filterStatus == 4 ? 'active' : ''
                }`}
                onClick={() => {
                  setFilterStatus(4);
                  setPageTypeData("hostedGig")
                  setPage(1)
                }}
              >
                Hosted Gigs</div>
              <div className={`nav_button_text ${filterStatus == 6 ? 'active' : ''
                }`}
                onClick={() => {
                  setFilterStatus(6);
                  setPageTypeData("reviewAndRating")
                  setPage(1)
                }}
              >
                Reviews & Ratings</div>
              <div className={`nav_button_text ${filterStatus == 7 ? 'active' : ''
                }`}
                onClick={() => {
                  setFilterStatus(7);
                  setPageTypeData("billAndPayment")
                  setPage(1)
                }}
              >
                Billing & Payment</div>
              <div className={`nav_button_text ${filterStatus == 8 ? 'active' : ''
                }`}
                onClick={() => {
                  setFilterStatus(8);
                  setPage(1)
                }}
              >
                View History</div>
            </div>

            {filterStatus == "1" && (
              <>
                <div div style={{ display: "flex", gap: "1rem" }}>
                  <div>
                    <div>
                      <p className="info_hadding">Personal Information</p>
                      <div className="user-data" style={{ height: "270px" }}>
                        <p className="info_border">Qualification <span>{userDetails?.educationQualification}</span></p>
                        <p className="info_border">Date of Birth <span>{extractOnlyDate(userDetails?.dateOfBirth)}</span></p>
                        <p className="info_border">Device Type <span>
                          {userDetails?.sessionData?.deviceType === "android" ? (
                            <img src={android} style={{ width: "22px", height: "22px" }} />
                          ) : userDetails?.sessionData?.deviceType === "ios" ? (
                            <GrApple style={{ fontSize: "20px", color: "#424245" }} />
                          ) : (
                            "Logged Out"
                          )}
                        </span></p>
                        <p className="info_border" >Device Name <span>{userDetails?.sessionData?.deviceName || 'N/A'}</span></p>
                        <p className="info_border" >Zip Code <span>{userDetails?.zipCode || 'N/A'}</span></p>
                        <p className="info_border" style={{ border: "none" }}>Experience
                          <span>
                            {userDetails?.totalExperience
                              ? userDetails.totalExperience >= 12
                                ? `${Math.floor(userDetails.totalExperience / 12)} year${Math.floor(userDetails.totalExperience / 12) !== 1 ? 's' : ''} 
                             ${userDetails.totalExperience % 12} month${userDetails.totalExperience % 12 !== 1 ? 's' : ''}`
                                : `${userDetails.totalExperience % 12} month${userDetails.totalExperience % 12 !== 1 ? 's' : ''}`
                              : 'N/A'}
                          </span>
                        </p>
                      </div>
                    </div>

                  </div>
                  <div >
                    <p className="info_hadding">{userDetails?.documents?.documentType}</p>
                    <div className="id_card">
                      <div className="view_id">
                        <p>Front View</p>
                        <div className="id_upload">
                          {/* <img src={userDetails?.documents?.backImage?.value} style={{ height: "211px", width: "330px", borderRadius: "18px" }} /> */}
                          <img
                            src={userDetails?.documents?.frontImage?.value}

                            className="license-img"
                            onClick={() => handleImageClick(userDetails?.documents?.frontImage?.value)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                      <div className="view_id">
                        <p>Back View</p>
                        <div className="id_upload">
                          {/* <img src={userDetails?.documents?.frontImage?.value} style={{ height: "211px", width: "330px", borderRadius: "18px" }} /> */}
                          <img
                            src={userDetails?.documents?.backImage?.value}
                            className="license-img"
                            onClick={() => handleImageClick(userDetails?.documents?.backImage?.value)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="certificate_data">
                  <p className="info_hadding">Certificates</p>
                  <TableContainer className={classes.tableMainContainer}>
                    <Table >
                      {userCertificate && userCertificate.length > 0 ? (
                        <TableBody >
                          {userCertificate.map((user, index) => (
                            <TableRow className={classes.tableBodyRow} key={user._id} >
                              <TableCell className={classes.textMiddle}>

                                <div style={{ textAlign: "left", fontFamily: "Roboto", fontWeight: "600", fontSize: "14px", marginLeft: "1.5rem" }}>
                                  <p>{get(user, "certificateName", "---")}</p>

                                </div>
                                <div className="Id_data">
                                  <span>{get(user, "issueBy", "---")}</span> |
                                  <span style={{ marginLeft: "0.5rem", }}>Certificate ID : {get(user, "certificateId", "---")}</span>
                                </div>

                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div
                                  style={{
                                    marginTop: "2rem",
                                    color: "#000000",
                                    fontStyle: "italic",
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    textAlign: "left"
                                  }}>
                                  <p>Issued on  {extractOnlyMonthYear(get(user, "issueDate", "---"))}</p>
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div className="download_certi"
                                  onClick={() => downloadCertificate(get(user, "uploadCertificate", "---"))}
                                >
                                  <div >

                                    <div>
                                      {
                                        get(user, "uploadCertificate", "").slice(-3).toLowerCase() === "pdf" ? (
                                          <img src={Pdf} style={{ height: "1.2rem" }} alt="PDF icon" />
                                        ) : (
                                          <img src={JPG} style={{ height: "1.2rem" }} alt="Image icon" />
                                        )
                                      }
                                    </div>

                                  </div>
                                  <div style={{ fontSize: "12px" }} >{get(user, "uploadCertificate", "---").split("/").pop()}</div>
                                  <div className="fileKB">
                                    {get(user, "docSize") ? `${(get(user, "docSize") / 1024).toFixed(2)} KB` : "---"}
                                  </div>

                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "0.5rem",
                                    alignItems: "end",
                                    justifyContent: "center",
                                    textAlign: "right"
                                  }}>
                                  {(() => {
                                    const status = get(user, "status", "---");
                                    if (status === "1") {
                                      return (

                                        <>
                                          {!(!canEdit && adminData?.userType === "subAdmin") && (
                                            <>
                                              <div
                                                style={{
                                                  padding: "5px 1.5rem",
                                                  background: "#FF4141",
                                                  color: "#FFFFFF",
                                                  fontFamily: "Inter",
                                                  fontWeight: "400",
                                                  borderRadius: "4px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                  setRejectCertificate(true);
                                                  setCertificateId({ id: user?._id });
                                                }}
                                              >
                                                Reject
                                              </div>
                                              <div
                                                style={{
                                                  width: "6rem",
                                                  padding: "5px 1.1rem",
                                                  background: "#2CA63F",
                                                  color: "#FFFFFF",
                                                  fontFamily: "Inter",
                                                  fontWeight: "400",
                                                  borderRadius: "4px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                  setApprovedCertificate(true);
                                                  setCertificateId({ id: user?._id });
                                                }}
                                              >
                                                Approve
                                              </div>
                                            </>
                                          )}
                                        </>
                                      );
                                    } else if (status === "2") {
                                      return <div
                                        style={{
                                          backgroundColor: "#F3F7FF",
                                          padding: "1rem",
                                          fontSize: "12px",
                                          textAlign: "center"
                                        }}
                                      >Certificate is approved by <br /> Admin at  {extractDate(get(user, "approvedDate", "---"))}
                                      </div>;
                                    } else if (status === "3") {
                                      return <div
                                        style={{
                                          backgroundColor: "#FFEFEF",
                                          padding: "1rem",
                                          fontSize: "12px",
                                          textAlign: "center",
                                          color: "#FF493A"
                                        }}
                                      >Certificate is Rejected by <br /> Admin at {extractDate(get(user, "approvedDate", "---"))}</div>;
                                    } else {
                                      return <div>---</div>;
                                    }
                                  })()}
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      ) : (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={4} align="center">
                              <NoResults />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>

                </div>
              </>
            )}

            {filterStatus == "2" && (
              <>
                <div>
                  <div style={{ display: "flex", gap: "1rem", }}>
                    <div className="Activity">Submitted Proposal <div className="activitiCount_Data">{rejectedCount?.data?.totalDocs ?? 0}</div></div>
                    <div className="Activity">Active Gigs <div className="activitiCount_Data">{rejectedCount?.activeGigCount ?? 0}</div></div>
                    <div className="Activity">Hire Request Pending  <div className="activitiCount_Data">{rejectedCount?.hireRequestPendingCount ?? 0}</div></div>
                    <div className="Activity">Completed Gigs  <div className="activitiCount_Data">{rejectedCount?.completedCount ?? 0}</div></div>
                    <div className="Activity">Earnings  <div className="activitiCount_Data">{rejectedCount?.earnings ?? 0}</div></div>
                    <div className="Activity">Not Selected <div className="activitiCount_Data">{rejectedCount?.rejectedCount ?? 0}</div></div>
                  </div>
                  
                  <div className="stepper_container">
                    {(activityGigStatus) && activityGigStatus.length > 0 ? (
                      activityGigStatus.map((data, index) => (
                        <div className="stepper_item" key={index}>
                          <div className="stepper_line" />
                          <div className="stepper_dot" />
                          <div className="stepper_content">
                            <div className="GigActivityData">
                              <div style={{ padding: "10px", display: "flex", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", gap: "10px" }}>
                                  <div >
                                    {data.gigUserType === "host" && (
                                      <img
                                        src={data?.workerDetails?.profileImage || placeholder}
                                        style={{ height: "2.4rem", width: "2.4rem", borderRadius: "50%" }}
                                        alt="Profile"
                                      />
                                    )}
                                    {data.gigUserType === "worker" && (
                                      <img
                                        src={data?.hostDetails?.profileImage || placeholder}
                                        style={{ height: "2.4rem", width: "2.4rem", borderRadius: "50%" }}
                                        alt="Profile"
                                      />
                                    )}
                                  </div>
                                  <div style={{ lineHeight: "100%" }}>
                                    {data.gigUserType === "host" && (
                                      <>
                                        <div className="activityData">{(get(data, "workerDetails.firstName", "---"))} {(get(data, "workerDetails.lastName", "---"))} applied to {(get(data, "gigDetails.gigTitle", "---"))}</div>
                                        <div className="activityData">posted by {(get(data, "hostDetails.firstName", "---"))} {(get(data, "hostDetails.lastName", "---"))}</div>
                                      </>
                                    )}
                                    {data.gigUserType === "worker" && (
                                      <>
                                        <div className="activityData">{(get(data, "hostDetails.firstName", "---"))} {(get(data, "hostDetails.lastName", "---"))} applied to {(get(data, "gigDetails.gigTitle", "---"))}</div>
                                        <div className="activityData">posted by {(get(data, "workerDetails.firstName", "---"))} {(get(data, "workerDetails.lastName", "---"))}</div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div style={{ display: "flex", gap: "3rem", marginRight: "3rem" }}>
                                  <div
                                    style={{
                                      padding: "1px 10px",
                                      borderRadius: "31px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "12px",
                                      color:
                                        get(data, "gigDetails.status") === "1"
                                          ? "#5088FB"
                                          : get(data, "gigDetails.status") === "0"
                                            ? "#21272A"
                                            : get(data, "gigDetails.status") === "3"
                                              ? "#FB5050"
                                              : get(data, "gigDetails.status") === "4"
                                                ? "#2CA63F"
                                                : get(data, "gigDetails.status") === "5"
                                                  ? "#FF6200"
                                                  : get(data, "gigDetails.status") === "6"
                                                    ? "#44B155"
                                                    : "inherit",
                                      backgroundColor:
                                        get(data, "gigDetails.status") === "1"
                                          ? "#EBF2FF"
                                          : get(data, "gigDetails.status") === "0"
                                            ? "#D6D6D6"
                                            : get(data, "gigDetails.status") === "3"
                                              ? "#FFEBEB"
                                              : get(data, "gigDetails.status") === "4"
                                                ? "#EAFFED"
                                                : get(data, "gigDetails.status") === "5"
                                                  ? "#FFF5E9"
                                                  : get(data, "gigDetails.status") === "6"
                                                    ? "#EAFFED"
                                                    : "inherit",
                                    }}>{get(data, "gigDetails.status") === "1"
                                      ? "Active"
                                      : get(data, "gigDetails.status") === "0"
                                        ? "Inactive"
                                        : get(data, "gigDetails.status") === "3"
                                          ? "Expired"
                                          : get(data, "gigDetails.status") === "4"
                                            ? "Hired"
                                            : get(data, "gigDetails.status") === "5"
                                              ? "Ongoing"
                                              : get(data, "gigDetails.status") === "6"
                                                ? "Completed"
                                                : "---"}</div>
                                  {data.gigUserType === "host" && (
                                    <div className="activitiDateData">{(extractDate(get(data, "workerDetails.createdAt", "---")))}</div>
                                  )}
                                  {data.gigUserType === "worker" && (
                                    <div className="activitiDateData">{(extractDate(get(data, "hostDetails.createdAt", "---")))}</div>
                                  )}
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="no-data"><NoResults /></div>
                    )}
                  </div>
                </div>


              </>
            )}

            {filterStatus == "3" && (
              <>
                <TableContainer className={classes.tableMainContainer}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow className={classes.tableHeadingRow} >
                        <TableCell className={classes.tableHeadingCell}>S.No</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig Applied Date</TableCell>
                        <TableCell className={classes.tableHeadingCell}>User ID</TableCell>
                        <TableCell className={classes.tableHeadingCell}>User Name</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Streak</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Ratings</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Proposal Sent</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Website</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Email Address</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Address</TableCell>
                      </TableRow>
                    </TableHead>
                    {isLoading && userGigStatus && userGigStatus.length > 0 ? (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                            <Loading />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : userGigStatus && userGigStatus.length > 0 ? (
                      <>
                        <TableBody>
                          {userGigStatus.map((user, index) => (
                            <TableRow className={classes.tableBodyRow} key={user._id} >
                              <TableCell className={classes.textMiddle}>
                                {index + 1 + rowsPerPage * (page - 1)}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {extractOnlyDate(get(user, "gigDetails.createdAt", "---"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>
                                  {get(user, "gigUserType") === "host"
                                    ? get(user, "hostDetails.userId", "---")
                                    : get(user, "gigUserType") === "worker"
                                      ? get(user, "workerDetails.userId", "---")
                                      : "---"}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle} >
                                <div style={{ display: "flex", gap: "2px", alignItems: "center", justifyContent: "center" }}>
                                  <div><img src={medal} style={{}} /></div>
                                  <div style={{ color: "#5088FB", textDecoration: "underline" }} >
                                    {get(user, "gigUserType") === "host"
                                      ? get(user, "hostDetails.firstName", "---") + " " + get(user, "hostDetails.lastName", "---")
                                      : get(user, "gigUserType") === "worker"
                                        ? get(user, "workerDetails.firstName", "---") + " " + get(user, "workerDetails.lastName", "---")
                                        : "---"}
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center"
                                }}>
                                <div className="container-Leader">
                                  <img src={Fire} className="fire-img-Leader" />
                                  <div className="center-text-Leader">{get(user, "workerStreakDetails.streakCount", "0")}</div>
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <div style={{
                                    width: "41px",
                                    height: "21px",
                                    background: "#FFF4E7",
                                    border: "0.75px solid #0000001F",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "2px"

                                  }}>
                                    {get(user, "hostFeedbackDetails.averageRating")?.toFixed(1) ?? "0"} <img src={Star} />
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <ReactReadMoreReadLess
                                  charLimit={10}
                                  readMoreText={"Read more"}
                                  readLessText={"Read less"}
                                  readMoreStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                  readLessStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                >
                                  {get(user, "invitationMsg", "---")}
                                </ReactReadMoreReadLess>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div style={{ textDecoration: "underline", color: "#5088FB" }}>
                                  {user?.gigUserType === "host"
                                    ? get(user, "hostDetails.websiteUrl") || "N/A"
                                    : user?.gigUserType === "worker"
                                      ? get(user, "workerDetails.websiteUrl") || "N/A"
                                      : "N/A"}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>
                                  {user?.gigUserType === "host"
                                    ? get(user, "hostDetails.email") || "N/A"
                                    : user?.gigUserType === "worker"
                                      ? get(user, "workerDetails.email") || "N/A"
                                      : "N/A"}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>
                                  {user?.gigUserType === "host"
                                    ? `${get(user, "hostDetails.city", "")}, ${get(user, "hostDetails.state", "")}` || "N/A"
                                    : user?.gigUserType === "worker"
                                      ? `${get(user, "workerDetails.city", "")}, ${get(user, "workerDetails.state", "")}` || "N/A"
                                      : "N/A"}
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </>
                    ) : (
                      <>
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={13} align="center" style={{ padding: "2rem" }}>
                              <DashHeading style={{ textAlign: "center", padding: "2rem", color: "#0000000" }}><NoResults /></DashHeading>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </>
                    )}
                  </Table>
                </TableContainer>
                {(userGigStatus && userGigStatus.length > 0) && (
                  <>
                    <Stack spacing={2} className={classes.paginationContainer}>
                      <Pagination
                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                        page={page}
                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                        renderItem={(item) => (
                          <PaginationItem
                            slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                            {...item}
                          />
                        )}
                      />
                    </Stack>
                  </>
                )}
              </>
            )}

            {filterStatus == "4" && (
              <>
                <TableContainer className={classes.tableMainContainer}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow className={classes.tableHeadingRow} >
                        <TableCell className={classes.tableHeadingCell}>S.No</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Status</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig Applied Date</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig ID</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig Title</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig Description</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Proposal Received</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Hired</TableCell>

                        <TableCell className={classes.tableHeadingCell}>Pay Type</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig Type</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig Start Date</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig End Data</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig Hours</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Amount ($)</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Location</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Skills Required</TableCell>
                        {/* <TableCell className={classes.tableHeadingCell}>Document Uploaded</TableCell> */}
                      </TableRow>
                    </TableHead>
                    {/* {userGigStatus && userGigStatus.length > 0 ? (
                      <> */}
                    {isLoading && userGigStatus && userGigStatus.length > 0 ? (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                            <Loading />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : userGigStatus && userGigStatus.length > 0 ? (
                      <>
                        <TableBody>
                          {userGigStatus.map((user, index) => (
                            <TableRow className={classes.tableBodyRow} key={user._id} >
                              <TableCell className={classes.textMiddle}>
                                {index + 1 + rowsPerPage * (page - 1)}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>

                                <div
                                  style={{
                                    padding: "3px 29px",
                                    borderRadius: "31px",
                                    color:
                                      get(user, "status") === "1"
                                        ? "#5088FB"
                                        : get(user, "status") === "0"
                                          ? "#21272A"
                                          : get(user, "status") === "2"
                                            ? "#FB5050"
                                            : get(user, "status") === "3"
                                              ? "#FB5050"
                                              : get(user, "status") === "4"
                                                ? "#2CA63F"
                                                : get(user, "status") === "5"
                                                  ? "#FF6200"
                                                  : get(user, "status") === "6"
                                                    ? "#44B155"
                                                    : "inherit",
                                    backgroundColor:
                                      get(user, "status") === "1"
                                        ? "#EBF2FF"
                                        : get(user, "status") === "0"
                                          ? "#D6D6D6"
                                          : get(user, "status") === "2"
                                            ? "#FFEBEB"
                                            : get(user, "status") === "3"
                                              ? "#FFEBEB"
                                              : get(user, "status") === "4"
                                                ? "#EAFFED"
                                                : get(user, "status") === "5"
                                                  ? "#FFF5E9"
                                                  : get(user, "status") === "6"
                                                    ? "#EAFFED"
                                                    : "inherit",
                                  }}
                                >
                                  {get(user, "status") === "1"
                                    ? "Active"
                                    : get(user, "status") === "0"
                                      ? "Inactive"
                                      : get(user, "status") === "2"
                                        ? "Blocked"
                                        : get(user, "status") === "3"
                                          ? "Expired"
                                          : get(user, "status") === "4"
                                            ? "Hired"
                                            : get(user, "status") === "5"
                                              ? "Ongoing"
                                              : get(user, "status") === "6"
                                                ? "Completed"
                                                : "---"}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {extractOnlyDate(get(user, "createdAt", "---"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {(get(user, "gigDetailId", "---"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div style={{
                                  textDecoration: "underline", color: "#5088FB", cursor: "pointer"
                                }}> {(get(user, "gigTitle", "---"))}</div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <ReactReadMoreReadLess
                                  charLimit={10}
                                  readMoreText={"Read more"}
                                  readLessText={"Read less"}
                                  readMoreStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                  readLessStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                >
                                  {get(user, "gigDescription", "---")}
                                </ReactReadMoreReadLess>
                                {/* {get(user, "gigDescription", "---")} */}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>
                                  {(get(user, "proposalCount", "---"))}
                                </div>
                              </TableCell>

                              <TableCell className={classes.textMiddle}>
                                <div>
                                  {user?.gigUserType === "worker"
                                    ? `${get(user, "hostDetails.firstName", "---")} ${get(user, "hostDetails.lastName", "---")}`
                                    : user?.gigUserType === "host"
                                      ? `${get(user, "workertDetails.firstName", "---")} ${get(user, "workertDetails.lastName", "---")}`
                                      : "---"}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div style={{ textTransform: "capitalize" }}>
                                  {(get(user, "gigPayType", "---"))}
                                </div>

                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div style={{ textTransform: "capitalize" }}>
                                  {(get(user, "gigType", "---"))}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {extractOnlyDate(get(user, "startDate", "---"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {extractOnlyDate(get(user, "endDate", "---"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>
                                  {get(user, "totalGigHrsRequire") ? get(user, "totalGigHrsRequire") : "N/A"}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {(get(user, "transactionDetails.amount", "N/A"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>
                                  {get(user, "zipCode") ? get(user, "zipCode") : "N/A"}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                                  {(get(user, "skillRequired", [])).map((skill, index) => (
                                    <div key={index}
                                      style={{
                                        border: "1px solid #0000001F",
                                        background: "#F3F7FF",
                                        borderRadius: "4px",
                                        padding: "2px 10px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",

                                      }}>{skill}</div>
                                  ))}
                                </div>
                              </TableCell>





                            </TableRow>
                          ))}
                        </TableBody>
                      </>
                    ) : (
                      <>
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={13} align="center" style={{ padding: "2rem" }}>
                              <DashHeading style={{ textAlign: "center", padding: "2rem", color: "#0000000" }}><NoResults /></DashHeading>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </>
                    )}
                  </Table>
                </TableContainer>
                {(userGigStatus && userGigStatus.length > 0) && (
                  <>
                    <Stack spacing={2} className={classes.paginationContainer}>
                      <Pagination
                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                        page={page}
                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                        renderItem={(item) => (
                          <PaginationItem
                            slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                            {...item}
                          />
                        )}
                      />
                    </Stack>
                  </>
                )}
              </>
            )}

            {filterStatus == "6" && (

              <>
                <div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div className="nav-button">
                      <div className={`nav-button-text ${tabSwitch == 1 ? 'active' : ''
                        }`}
                        onClick={() => {
                          setTabSwitch(1);
                          setTypeData("worker")
                        }}
                      >
                        Job Seeker</div>
                      <div className={`nav-button-text ${tabSwitch == 2 ? 'active' : ''
                        }`}
                        onClick={() => {
                          setTabSwitch(2);
                          setTypeData("host")
                        }}
                      >
                        Job Host</div>
                    </div>
                  </div>


                  {tabSwitch == 1 && (
                    <div className="Rattings">
                      <div className="OverallRatting">
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                          <div>Overall Rating</div>
                          <div className="FiveStar">{(overAllReating?.overallAverage || 0).toFixed(1)}</div>
                          <Stars
                            count={5}
                            value={parseFloat(overAllReating?.overallAverage) || 0} // fallback to 0 if undefined
                            size={28}
                            edit={false}
                            half={true}
                            color2="#FFAE46" // Yellow/Orange color
                          />
                          <div className="reatingBasedData">Based on {overAllReating?.totalFeedbacks || 0} rating</div>
                        </div>
                        <div style={{ display: "flex", gap: "1rem", marginTop: "2rem" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                            <div className="rettingDataType">Punctuality</div>
                            <div className="rettingDataType">Professionalism</div>
                            <div className="rettingDataType">Work Quality</div>
                            <div className="rettingDataType">Dedication & Effort</div>
                            <div className="rettingDataType">Skills & Competence</div>
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgPunctuality || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgProfessionalism || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgWorkQuality || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgDedicationAndEffort || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgSkillAndCompetence || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="CommentRatting">
                        {reatingStatus && reatingStatus.length > 0 ? (
                          reatingStatus.map((user, index) => (

                            <div key={index}>
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", gap: "0.5rem" }}>
                                  <img
                                    src={get(user, "userDetails.profileImage") || placeholder}
                                    alt="User"
                                    style={{ height: "2.5rem", width: "2.5rem", borderRadius: "50%" }}
                                  />
                                  <div>
                                    <div className="ReviewNameData"> {(get(user, "userDetails.userName", "---"))}<img src={medal} style={{ height: "1.5rem" }} /></div>

                                  </div>
                                </div>

                                <div className="ReviewNameDataList">{extractOnlyDate(get(user, "createdAt", "---"))}</div>
                              </div>

                              <div>
                                <Stars
                                  count={5}
                                  value={(get(user, "averageRating", "---"))}
                                  size={20}
                                  edit={false}
                                  half={true}
                                  color2="#FFAE46"
                                />
                              </div>

                              <div className="ReviewNameDataList">{(get(user, "feedbackDescription", "---"))}</div>
                            </div>
                          ))
                        ) : (
                          <p><NoResults /></p>
                        )}

                      </div>
                    </div>
                  )}

                  {tabSwitch == 2 && (
                    <div className="Rattings">
                      <div className="OverallRatting">
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                          <div>Overall Rating</div>
                          <div className="FiveStar">{(overAllReating?.overallAverage || 0).toFixed(1)}</div>
                          <Stars
                            count={5}
                            value={parseFloat(overAllReating?.overallAverage) || 0} // fallback to 0 if undefined
                            size={28}
                            edit={false}
                            half={true}
                            color2="#FFAE46" // Yellow/Orange color
                          />
                          <div className="reatingBasedData">Based on {overAllReating?.totalFeedbacks || 0} rating</div>
                        </div>
                        <div style={{ display: "flex", gap: "1rem", marginTop: "2rem" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                            <div className="rettingDataType">Response Time</div>
                            <div className="rettingDataType">Professionalism</div>
                            <div className="rettingDataType">Communication</div>
                            <div className="rettingDataType">Work Environment</div>
                            <div className="rettingDataType">Ease of Payment Process</div>
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgTimelyCommunication || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgClarityOfWork || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgTimelyCommunication || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgWorkEnvironment || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                            <div className="progressBar">
                              <div style={{
                                background: "#5088FB",
                                width: `${(overAllReating?.avgWillingToWorkAgain || 0) * 20}%`,
                                height: "5px",
                                borderRadius: "4px",
                              }}>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="CommentRatting">
                        {reatingStatus && reatingStatus.length > 0 ? (
                          reatingStatus.map((user, index) => (

                            <div key={index}>
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", gap: "0.5rem" }}>
                                  <img
                                    src={get(user, "userDetails.profileImage") || placeholder}
                                    alt="User"
                                    style={{ height: "2.5rem", width: "2.5rem", borderRadius: "50%" }}
                                  />
                                  <div>
                                    <div className="ReviewNameData"> {(get(user, "userDetails.userName", "---"))}<img src={medal} style={{ height: "1.5rem" }} /></div>

                                  </div>
                                </div>

                                <div className="ReviewNameDataList">{extractOnlyDate(get(user, "createdAt", "---"))}</div>
                              </div>

                              <div>
                                <Stars
                                  count={5}
                                  value={(get(user, "averageRating", "---"))}
                                  size={20}
                                  edit={false}
                                  half={true}
                                  color2="#FFAE46"
                                />
                              </div>

                              <div className="ReviewNameDataList">{(get(user, "feedbackDescription", "---"))}</div>
                            </div>
                          ))
                        ) : (
                          <p><NoResults /></p>
                        )}

                      </div>
                    </div>
                  )}

                </div>
              </>
            )}

            {filterStatus == "7" && (
              <>
                <div className="paymentCard">
                  <div className="payment_heading">Cards Added</div>

                  <div style={{ display: "flex", flexDirection: "row", gap: "1rem", alignItems: "center", overflow: "scroll" }}>
                    {cardDetails && cardDetails.length > 0 ? (
                      cardDetails.map((card, index) => (
                        <div key={index}>
                          <div className="cardDetails">
                            <div>
                              <img
                                src={
                                  card.brand?.toLowerCase().startsWith("visa")
                                    ? visa
                                    : card.brand?.toLowerCase().startsWith("amez")
                                      ? amez
                                      : card.brand?.toLowerCase().startsWith("diner")
                                        ? diner
                                        : card.brand?.toLowerCase().startsWith("discover")
                                          ? discover
                                          : card.brand?.toLowerCase().startsWith("jcb")
                                            ? jcb
                                            : card.brand?.toLowerCase().startsWith("mada")
                                              ? mada
                                              : card.brand?.toLowerCase().startsWith("maestro")
                                                ? maestro
                                                : card.brand?.toLowerCase().startsWith("mastercard")
                                                  ? mastercard
                                                  : card.brand?.toLowerCase().startsWith("union")
                                                    ? union
                                                    : defaultImage
                                }
                                alt="Bank Logo"
                                style={{ width: "50px", height: "auto" }}
                              />
                            </div>
                            <div>
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {card.name || "Unknown Bank"}
                                {card.isDefaultCard == true && <div style={{ background: "#4949491C", padding: "0px 5px", borderRadius: "44px", fontSize: "14px" }}>Default</div>}

                              </div>

                              <div style={{
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "#0000008C",
                              }}
                              >XXXX-XXXX-XXXX-{card.last4 || "****"}</div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div>No card details available.</div>
                    )}
                  </div>
                </div>


                <DashboardHeading style={{ display: "flex", justifyContent: "space-between", }}>
                  <div>Payment History</div>


                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div className="nav-button">
                      <div className={`nav-button-text ${tabSwitchPayment == 1 ? 'active' : ''
                        }`}
                        onClick={() => {
                          setTabSwitchPayment(1);
                          setPaymentTypeData("paid")
                        }}
                      >
                        Paid</div>
                      <div className={`nav-button-text ${tabSwitchPayment == 2 ? 'active' : ''
                        }`}
                        onClick={() => {
                          setTabSwitchPayment(2);
                          setPaymentTypeData("received")
                        }}
                      >
                        Received </div>
                    </div>
                  </div>
                </DashboardHeading>


                <TableContainer className={classes.tableMainContainer}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow className={classes.tableHeadingRow} >
                        <TableCell className={classes.tableHeadingCell}>S.No</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Status</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Transaction ID</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Date</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Paid To</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Paid Through</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Total Amount ($)</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Gig Amount</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Admin Commission</TableCell>

                      </TableRow>
                    </TableHead>
                    {/* {userGigStatus && userGigStatus.length > 0 ? (
                      <> */}
                    {isLoading && userGigStatus && userGigStatus.length > 0 ? (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                            <Loading />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : userGigStatus && userGigStatus.length > 0 ? (
                      <>
                        <TableBody>
                          {userGigStatus.map((user, index) => (
                            <TableRow className={classes.tableBodyRow} key={user._id} >
                              <TableCell className={classes.textMiddle}>
                                {index + 1 + rowsPerPage * (page - 1)}
                              </TableCell>
                              {tabSwitchPayment == 1 && (
                                <TableCell className={classes.textMiddle}>
                                  <div style={{
                                    color: "#14A039",
                                    backgroundColor: "#EAFFED", // Green background
                                    padding: "0.1rem 2rem",
                                    borderRight: "30px",
                                    fontSize: "14px"
                                  }}>
                                    {get(user, "paymentStatus") === 1 ? "Received" : "Paid"}
                                  </div>
                                </TableCell>
                              )}
                              {tabSwitchPayment == 2 && (
                                <TableCell className={classes.textMiddle}>
                                  <div style={{
                                    color: "#14A039",
                                    backgroundColor: "#EAFFED", // Green background
                                    padding: "0.1rem 2rem",
                                    borderRight: "30px",
                                    fontSize: "14px"
                                  }}>
                                    {get(user, "status") === "completed" ? "Received" : "Paid"}
                                  </div>
                                </TableCell>
                              )}
                              <TableCell className={classes.textMiddle}>
                                {(get(user, "transactionId", "---"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>
                                  {extractOnlyDate(get(user, "createdAt", "---"))}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {get(user, "workerDetails.firstName", "---")} {get(user, "workerDetails.lastName", "---")}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                XXXX-XXXX-XXXX-{(get(user, "cardDetails.last4", "---"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {get(user, "amount", "---")}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {(get(user, "gigPaymentSummaryParsed.gigAmount", "0"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {get(user, "gigPaymentSummaryParsed.platformCommissionFee", "0")}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </>
                    ) : (
                      <>
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={13} align="center" style={{ padding: "2rem" }}>
                              <DashHeading style={{ textAlign: "center", padding: "2rem", color: "#0000000" }}><NoResults /></DashHeading>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </>
                    )}
                  </Table>
                </TableContainer>
                {(userGigStatus && userGigStatus.length > 0) && (
                  <>
                    <Stack spacing={2} className={classes.paginationContainer}>
                      <Pagination
                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                        page={page}
                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                        renderItem={(item) => (
                          <PaginationItem
                            slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                            {...item}
                          />
                        )}
                      />
                    </Stack>
                  </>
                )}

              </>
            )}

            {filterStatus == "8" && (
              <>
                <TableContainer className={classes.tableMainContainer}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow className={classes.tableHeadingRow} >
                        <TableCell className={classes.tableHeadingCell}>S.No</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Request Date</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Request Status</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Request Updated Time</TableCell>
                        <TableCell className={classes.tableHeadingCell}>Request Updated By</TableCell>
                      </TableRow>
                    </TableHead>
                    {/* {userHistory && userHistory.length > 0 ? (
                      <> */}
                    {isLoading && userHistory && userHistory.length > 0 ? (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                            <Loading />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : userHistory && userHistory.length > 0 ? (
                      <>
                        <TableBody>
                          {userHistory.map((user, index) => (
                            <TableRow className={classes.tableBodyRow} key={user._id} >
                              <TableCell className={classes.textMiddle}>
                                {index + 1 + rowsPerPage * (page - 1)}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {extractOnlyDate(get(user, "requestDate", "---"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {user.requestStatus === "2" && (
                                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <button className="green-btn">Approved</button>
                                  </div>
                                )}

                                {user.requestStatus === "3" && (
                                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                                    <button className="block-btn">Rejected</button>
                                    <div
                                      className="view_reason"
                                      onClick={(e) => {
                                        setPopoverUserDetails(user);
                                        handleFilterClick(e);
                                      }}
                                    >
                                      View Reason
                                    </div>
                                  </div>
                                )}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {extractDate(get(user, "requestUpdatedTime", "---"))}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {get(user, "requestUpdatedBy", "---")}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </>
                    ) : (
                      <>
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={13} align="center" style={{ padding: "2rem" }}>
                              <DashHeading style={{ textAlign: "center", padding: "2rem", color: "#0000000" }}><NoResults /></DashHeading>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </>
                    )}
                  </Table>
                </TableContainer>
                {(userGigStatus && userGigStatus.length > 0) && (
                  <>
                    {/* <Stack spacing={2} className={classes.paginationContainer}>
                      <Pagination
                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                        page={page}
                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                        renderItem={(item) => (
                          <PaginationItem
                            slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                            {...item}
                          />
                        )}
                      />
                    </Stack> */}
                  </>
                )}
              </>
            )}




          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer >

      {/* Modal for Block User  */}
      < Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={blockModal}
        onClose={() => {
          setBlockModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div>
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2 style={{ cursor: "pointer" }} onClick={() => setBlockModal(false)} />
            </div>
            {
              userDetails?.isBlocked == 2 ? (
                <>
                  <p className="profile-section-text-data">Block User</p>
                  <div className="block-header">Are you sure you want to block this user? Please confirm.</div>
                </>
              ) : (
                <>
                  <p className="profile-section-text-data">Unblock User</p>
                  <div className="block-header">Are you sure you want to Unblock this user? Please confirm.</div>
                </>
              )
            }
          </div >
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setBlockModal(false);
                }}
              >
                Cancel
              </div>
              <div
                className="logout-button"
                style={{ background: "#EA5455", cursor: "pointer" }}
                onClick={() => {
                  setBlockModal(false);
                  blockUnblock()
                }}
              >
                Yes
              </div>

            </div>
          </>
        }
      />



      {/* Model for delete user */}
      < Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={deleteModal}
        onClose={() => {
          setDeleteModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div div >
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2 style={{ cursor: "pointer" }} onClick={() => setDeleteModal(false)} />
            </div>
            <p className="profile-section-text-data">Delete User</p>
            <div className="block-header">Are you sure you want to delete this user? Please confirm.</div>
          </div >
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setDeleteModal(false);

                }}
              >
                Cancel
              </div>
              <div
                className="logout-button"
                style={{ background: "#EA5455", cursor: "pointer" }}
                onClick={() => {
                  setDeleteModal(false);
                  navigate("/userManagement")
                  DeleteUser()
                }}
              >
                Yes
              </div>

            </div>
          </>
        }
      />

      {/* Modal for Showing Document */}
      {
        verificationDocumentModal && (
          <Modal
            maxWidth="lg"
            width="500px"
            RoundedCorners={true}
            isOpen={verificationDocumentModal}
            onClose={() => setVerificationDocumentModal(false)}
            backgroundModal={false}
            backgroundModalContent={false}
            title={
              <div className="d-flex align-items-center justify-content-end">
                <RxCross2
                  style={{ cursor: "pointer" }}
                  onClick={() => setVerificationDocumentModal(false)}
                />
              </div>
            }
            content={
              <div className="send-take-pkg-cant text-center">
                <div className="common-heading">Document Image</div>
                <img
                  src={selectedImage}
                  alt="Selected Document"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    borderRadius: "10px",
                    marginTop: "1rem"
                  }}
                />
              </div>
            }
          />
        )
      }



      {/* Popover for reson */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, width: "350px" }}>
          <div>
            <p className="user_info">Rejected Reason</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                {popoverUserDetails?.profileReason && (
                  <div>
                    Profile:&nbsp;
                    <span style={{ color: "red" }}>
                      {popoverUserDetails?.profileReason}
                    </span>
                  </div>
                )}

                {popoverUserDetails?.documentReason && (
                  <div>
                    Document:&nbsp;
                    <span style={{ color: "red" }}>
                      {popoverUserDetails?.documentReason}
                    </span>
                  </div>
                )}
                {popoverUserDetails?.stripeReason && (
                  <div>
                    Stripe:&nbsp;
                    <span style={{ color: "red" }}>
                      {popoverUserDetails?.stripeReason}
                    </span>
                  </div>
                )}

              </div>
            </div>
          </div>
        </Box>
      </Popover>


      {/* Model for Approved Certificate */}
      < Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={approvedCertificate}
        onClose={() => {
          setApprovedCertificate(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div div >
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2 style={{ cursor: "pointer" }} onClick={() => setApprovedCertificate(false)} />
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
              <img src={certificate} style={{ height: "3.5rem" }} />
            </div>

            <div className="block-header">Are you sure you want to approve this certificate ?</div>
          </div >
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setApprovedCertificate(false);

                }}
              >
                Cancel
              </div>
              <div
                className="logout-button"
                style={{ background: "#5088FB", cursor: "pointer" }}
                onClick={() => {
                  setApprovedCertificate(false);
                  handleApprove(certificateId?.id);
                }}
              >
                Yes
              </div>

            </div>
          </>
        }
      />

      {/* Model for Approved Certificate */}


      <Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={rejectCertificate}
        onClose={() => setRejectCertificate(false)}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div>
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2
                style={{ cursor: "pointer" }}
                onClick={() => setRejectCertificate(false)}
              />
            </div>
            <p className="user_info">Reject Certificate Reason</p>
            <div className="block-header">
              Please provide a reason for rejecting this certificate
            </div>
          </div>
        }
        content={
          <>
            <textarea
              placeholder="Write Reject reason..."
              className="reject-textarea"
              style={{
                height: "6rem",
                width: "100%",
                background: " #F3F7FF",
                border: "1px solid #00000038",
                padding: "0.5rem"
              }}
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
            ></textarea>

            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => setRejectCertificate(false)}
              >
                Cancel
              </div>
              <div
                className="logout-button"
                style={{ background: "#5088FB", cursor: "pointer" }}
                onClick={() => {
                  setRejectCertificate(false);
                  handleReject(certificateId?.id);
                }}
              >
                Submit
              </div>
            </div>
          </>
        }
      />

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDetails);

